import { QuestionType2UIConfig } from "../../../../../components/ui/question-type2-ui";
import { GeneralQuestionUIConfig, GeneralQuestionUIConfigOption } from "../../../../../cvp-webgames-core/Components/ui/react/core-general-question-ui";
import BaseScenarioPart from "../../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { ScoringType } from "../../../../../misc/tools";
import { GameBaseScenario } from "../../../../GameBaseScenario";
import { scenario4WcWorkStoppageAudioCaching, scenario4WcWorkStoppageVideoSegments } from "../../../scenario4-wc-work-stoppage";
import { WcWorkStoppageComponentsStep2ComponentMainConfig, WcWorkStoppageComponentsStep2ComponentPart1Config } from "../wc-work-stoppage-components-step2";

export default class WcWorkStoppageComponentsStep2Part1 extends BaseScenarioPart<GameBaseScenario> {

	private stepName="Step 3"
	private get config(): WcWorkStoppageComponentsStep2ComponentPart1Config {
		return this.mainConfig.part1Config;
	}
	constructor(scenario: GameBaseScenario, private onDone: () => void, private id: string, private mainConfig: WcWorkStoppageComponentsStep2ComponentMainConfig) {
		super(scenario);
	}

	public get partId(): string {
		return this.id;
	}

	public get videoUrl(): string[] {
		return [this.config.videoUrl];
	}

	public start() {
		this.section1();
	}

	public section1() {
		const context = this;
		this.mainConfig.scenario.uiWrapper.displayQuestonType2UI({
			audioUrl: scenario4WcWorkStoppageAudioCaching.getItemByKey(scenario4WcWorkStoppageAudioCaching.audioKeys.question5).src,
			title: this.mainConfig.scenario.props.name,
			subtitle: this.stepName,
			isYesCorrect: false,
			correctFeedback: `
				<p class="default-text">Correct. There is no history involving this type of behavior 
				or decision making with Dr. Jones. The repetitive occurrences section of the decision 
				support tool should be reviewed and considered prior to making your decision.</p>
			`,
			wrongFeedback: `
				<p class="default-text">This is not the best option. Dr. Jones has not previously been involved in a similar incident.</p>
			`,
			question: 'Were there repetitive occurrences with this type of behavior involving the employee?',
			onSubmitClicked: (isCorrect: boolean, feedback: string, selectedTitle: string, parentQuestion: QuestionType2UIConfig) => {
				const mentorInfo = scenario4WcWorkStoppageVideoSegments.getItemByKey('Feedback');
				context.scenario.onChoiceSubmittedQuestionType2(isCorrect, feedback, selectedTitle, this.stepName, parentQuestion, () => {
					context.section2();
				}, () => {
					context.section2();
				}, undefined, undefined, undefined, mentorInfo.src, mentorInfo.chapterIds[11], mentorInfo.chapterIds[12]);
			}
		},4);
	}

	public section2() {
		const context = this;
        this.mainConfig.scenario.setAreaForCurrentScenario(5);
		this.mainConfig.scenario.uiWrapper.displayIntroScreenUI({
			title: 'Re-Cap Summary Statement',
			subtitle: 'Scenario 4 - Gloving',
			recapFirst: 'In summary this is “Reckless Behavior.” ',
			htmlData: `
				<br/><li>The substitution test is NOT satisfied. 
				<br/><br/></li><li>Accountability lies solely with the employee in this instance. 
				<br/><br/></li><li>Systems issues should be analyzed and improved by leadership, but those issues are not mitigating factors in evaluating Dr. Jones’ behavior. 
				<br/><br/></li><li>There is no history involving this type of behavior with Dr. Jones. 
				<br/><br/></li><li>Discipline may be warranted.</li>
			`,
			okButton: 'Continue',
			onStartScenarioClicked: () => {
				context.onDone();
			},
			mentorUrl: scenario4WcWorkStoppageVideoSegments.getItemByKey('Feedback').src,
			mentorChapter: scenario4WcWorkStoppageVideoSegments.getItemByKey('Feedback').chapterIds[14]
		})
	}
}